import { ref, watch, type Ref } from "vue";
import { useRoute } from "vue-router";
import useStore from "../store.ts";
import { getDeviceIdFromRouteQuery, storeDeviceId } from "../utils/DeviceId.ts";

/* see docs/EXTRACTED_COMMENTS.md#c078 */
export function useRouteBindings(): { device: Ref<string> } {
    const route = useRoute();
    const store = useStore();
    const device = ref<string>("");

    watch(() => route.params.id, () => {
        store.loaded = false;
        if (route.params.id) {
            store.layout = Number(route.params.id);
        }
    });

    watch(() => route.query, () => {
        const deviceFromRoute = getDeviceIdFromRouteQuery(route.query as any);
        if (deviceFromRoute && device.value !== deviceFromRoute) {
            device.value = deviceFromRoute;
            storeDeviceId(deviceFromRoute);
            store.socketManager.sendDevice(deviceFromRoute);
        }
    });

    return { device };
}
